export default "__VITE_ASSET__DfJiawQ2__"